import { Button, Icon } from "@adasupport/byron";
import React from "react";

import { Txt } from "components/Common";
import { TextButton } from "components/Common/Primitives";
import { NO_OP_FUNCTION } from "services/helpers";

import { AdaCredentialsSection } from "./AdaCredentialsSection";
import { ZendeskCredentialsSection } from "./ZendeskCredentialsSection";
import * as S from "./styles";

export const ZendeskSMTPConnectorModal = () => {
  // Zendesk credentials
  const zendeskCredentials = {
    inboundHostname: "",
    smtpPort: "",
    username: "",
    password: "",
  };

  // Ada credentials (read-only values)
  const adaCredentials = {
    outboundHostname: "smtp.email.ada.support",
    smtpPort: "587",
    username: "Ada-lovelace",
  };

  return (
    <S.ModalContent>
      <h5>Setup SMTP connector for Zendesk</h5>
      <Txt color="main" size="small" lineHeight="default">
        Two sets of credentials are required to setup an SMTP connector. It is
        recommended to{" "}
        <Txt weight="bold">first complete the bring your own domain</Txt> setup
        found in the Email section of the Ada dashboard. You can learn more and
        access step-by-step instructions for setting up an SMTP connector on the{" "}
        <TextButton
          as="a"
          href="https://docs.ada.cx/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ada help docs
        </TextButton>{" "}
        site.
      </Txt>
      <S.Divider />
      <ZendeskCredentialsSection
        inboundHostname={zendeskCredentials.inboundHostname}
        smtpPort={zendeskCredentials.smtpPort}
        username={zendeskCredentials.username}
        password={zendeskCredentials.password}
      />
      <S.Divider />
      <AdaCredentialsSection
        outboundHostname={adaCredentials.outboundHostname}
        smtpPort={adaCredentials.smtpPort}
        username={adaCredentials.username}
      />
      <S.ModalBottom>
        <S.HelpLink
          as="a"
          href="https://docs.ada.cx/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon.Help width={24} height={24} />
          Need help?
        </S.HelpLink>
        <Button onClick={NO_OP_FUNCTION} text="Save" isDisabled={false} />
      </S.ModalBottom>
    </S.ModalContent>
  );
};
